<div>
    <div class="modal-header">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg" style="display: flex; align-items: center">
                <div class="modal-icon icon fill-white" style="width: 30px;" [inlineSVG]="'assets/ico/check-mark-white.svg'" alt="icon"></div>
                    <span class="modal-title" id="modal-basic-title">
                        <span> {{'project.successCreation' | translate}} </span>
                    </span>
                </div>
                <div class="modal-icon icon fill-white close-icon" (click)="close(false)" aria-label="close"
                    [inlineSVG]="'assets/ico/close-24px.svg'"></div>
            </div>
        </div>
    </div>
    <div class="modal-body">
        <div class="row p-3" style="margin-top: -20px;">
            <div class="form-group col-lg-12 mb-3" [innerHTML]="question">
            </div>
        </div>
    </div>
    <div class="modal-footer p-0">
        <div class="container-fluid m-0 p-0">
            <span class="btn modal-btn save back" (click)="close(true)">{{'buttons.send' | translate }}</span>
            <span class="btn modal-btn save" (click)="close(false)">  {{'buttons.ignore' | translate}}  </span>
        </div>
    </div>
</div>